export const getRadiusByPositionAndScreenSize = ({ zoom, position: { lat }, mapComponentSize: { width, height, }, }) => {
    const metersPerPixel = 156543.04
        * Math.cos(radians(lat))
        / Math.pow(2, zoom);
    const radiusInMeters = metersPerPixel
        * (width / 2 + height / 2);
    return radiusInMeters;
};
const radians = (degrees) => degrees * Math.PI / 180;
